/**
 * What the verify step says when the action behind the code is refused.
 *
 * It read only `data.error.message`, so a refusal that carries its reason in
 * `message` (the API's 400s do) showed "Error, Please try again !!!", as if
 * the code had been wrong.
 */
export const FALLBACK_OTP_ERROR = "Error, Please try again !!!";

export const otpErrorMessage = (error: any): string => {
  const data = error?.data ?? error?.response?.data;
  const reasons = [
    data?.error?.message,
    data?.message,
    data?.message?.detail,
    data?.detail,
  ];
  /* Some flows hand over the error already wrapped (action/utilities'
     errorWrapper): the reason is its own `message`, and `data` is null. A
     thrown Error's message is the library's ("Request failed with status
     code 400"), not a reason, so only a plain object's is read. A goal
     plan's confirmation showed the fallback that way, over the robo's
     reason. */
  if (!(error instanceof Error)) reasons.push(error?.message);
  const reason = reasons.find((r) => typeof r === "string" && r.trim());
  return reason ?? FALLBACK_OTP_ERROR;
};
